import React from "react";
import "./style.css";

const CustomCheckbox = ({ id, label, checked, setChecked,padding }) => {
  return (
    <div className="checkbox-wrapper-4">
      <input
        className="inp-cbx"
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => setChecked(e.target.checked)}
      />
      <label className="cbx" htmlFor={id} style={{padding:padding? padding: "6px 8px"}}>
        <span>
          <svg width="12px" height="10px">
            <use xlinkHref="#check-4"></use>
          </svg>
        </span>
        <span style={{fontSize:"14px",fontWeight:"600"}} >{label}</span>
      </label>

      {/* SVG SYMBOLS */}
      <svg className="inline-svg">
        <symbol id="check-4" viewBox="0 0 12 10">
          <polyline points="1.5 6 4.5 9 10.5 1" />
        </symbol>
      </svg>
    </div>
  );
};

export default CustomCheckbox;
